export default {
    'required': "必須項目です",
    'email': "メールアドレスが正しくありません",
    'min': "{min}文字以上で入力してしてください",
    'max': "{max}文字以下で入力してしてください",
    'confirmed_password': "確認用のパスワードが一致しません",
    'required_if': "必須項目です",
    'currentPassword': {
        'notMatch': '現在パスワードが正しくありません',
    },
    'model': {
        'filed': {
            'rule': "モデルが無効です"
        }
    },
    'login': {
        'email': {
            'required': 'メールを入力してください',
            'email': 'メールが正しくありません',
            'max': 'メールは100文字以下で入力してしてください',
        },
        'password': {
            'min': 'パスワードは6文字以上で入力してしてください',
            'max': 'パスワードは36文字以下で入力してしてください',
        },
        'rememberMe': {
            'nullable': 'ログインのままが無効です',
            'boolean': 'ログインのままが無効です'
        }
    },
    'register': {
        'email': {
            'required': 'メールを入力してください',
            'unique': 'メールは既に使用されています',
            'email': 'メールが正しくありません',
            'max': 'メールは255文字以下で入力してしてください'
        },
        'password': {
            'required': 'パスワードを入力してください',
            'min': 'パスワードは6文字以上で入力してしてください',
            'max': 'パスワードは36文字以下で入力してしてください',
        },
        'babyName': {
            'required': 'お子様の名前を入力してください',
            'max': 'お子様の名前は255文字以下で入力してしてください'
        },
        'babyBirthday': {
            'required': 'お子様の生年月日を入力してください',
            'dateFormat': 'お子様の生年月日の形式が無効です'
        }
    },
    'createBaby': {
        'babyName': {
            'required': 'お子様の名前を入力してください',
            'max': 'お子様の名前は255文字以下で入力してしてください'
        },
        'babyBirthday': {
            'required': 'お子様の生年月日を入力してください',
            'dateFormat': 'お子様の生年月日の形式が無効です'
        }
    },
    'updateProfile': {
        'email': {
            'required': 'メールを入力してください',
            'unique': 'メールは既に使用されています',
            'email': 'メールが正しくありません',
            'max': 'メールは255文字以下で入力してしてください'
        },
        'password': {
            'required': 'パスワードを入力してください',
            'min': 'パスワードは6文字以上で入力してしてください',
            'max': 'パスワードは36文字以下で入力してしてください',
        },
        'currentPassword': {
            'notMatch': '現在パスワードが正しくありません',
        },
        'passwordConfirmation': {
            'same': '確認用のパスワードが一致しません'
        },
        'babies': {
            'array': 'お子様の内容がは正しくありません',
            'name': {
                'required': 'お子様の名前を入力してください',
                'max': 'お子様の名前は255文字以下で入力してしてください'
            }

        }
    },
    'forgotPassword': {
        'email': {
            'notExists': 'メールが正しくありません'
        }
    },
    'max_file_size': "{max}以下の画像をアップロードしてください",
};
